/**
 * Expandable drawer that shows an audit record's before/after JSON
 * pretty-printed side-by-side. Rendered inline in the Audit Log page.
 */

import React from 'react';
import Column from '@amzn/meridian/column';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';
import { AuditRecord } from '../service/adminApiService';

function pretty(value: string | null | undefined): string {
  if (!value) return '(none)';
  try {
    return JSON.stringify(JSON.parse(value), null, 2);
  } catch {
    return value;
  }
}

export const AuditDetailDrawer: React.FC<{ record: AuditRecord }> = ({ record }) => {
  return (
    <Column spacing="small" spacingInset="400" backgroundColor="secondary" aria-label="Audit record detail">
      <Row widths={['fill', 'fill']} spacing="large" alignmentVertical="top" wrap="down">
        <Column spacing="xsmall">
          <Text type="b300">Before</Text>
          <pre
            style={{
              background: '#FFFFFF',
              border: '1px solid #D5DBDB',
              padding: '0.5rem',
              borderRadius: '4px',
              overflow: 'auto',
              maxHeight: '360px',
              fontSize: '12px',
              fontFamily: 'SFMono-Regular, Menlo, Monaco, Consolas, monospace',
            }}
          >
            {pretty(record.before_state)}
          </pre>
        </Column>
        <Column spacing="xsmall">
          <Text type="b300">After</Text>
          <pre
            style={{
              background: '#FFFFFF',
              border: '1px solid #D5DBDB',
              padding: '0.5rem',
              borderRadius: '4px',
              overflow: 'auto',
              maxHeight: '360px',
              fontSize: '12px',
              fontFamily: 'SFMono-Regular, Menlo, Monaco, Consolas, monospace',
            }}
          >
            {pretty(record.after_state)}
          </pre>
        </Column>
      </Row>
      <Text type="b200" color="secondary">
        change_id: {record.change_id} · request_id: {record.request_id || '(none)'}
      </Text>
    </Column>
  );
};
